import { combineReducers } from "redux";
import theme from "./slices/themeSlice";
import auth from "./slices/authSlice";
import banner from "./slices/bannerSlice";
import category from "./slices/categorySlice";
import product from "./slices/productSlice";
import user from "./slices/userSlice";
import order from "./slices/orderSlice";
import information from "./slices/informationSlice";
import coupon from "./slices/couponSlice";
import sale from "./slices/saleSlice";
import setting from "./slices/settingSlice";
import variant from "./slices/variantSlice";
import notification from "./slices/notificationSlice";
import pos from "./slices/posSlice";
import returnsReport from "./slices/returnsReportSlice";
import returnManagement from "./slices/returnManagementSlice";
import ticket from "./slices/ticketSlice";

const rootReducer = (asyncReducers) => (state, action) => {
  const combinedReducer = combineReducers({
    theme,
    auth,
    banner,
    category,
    product,
    order,
    sale,
    coupon,
    user,
    information,
    setting,
    variant,
    notification,
    pos,
    returnsReport,
    returnManagement,
    ticket,
    ...asyncReducers,
  });
  return combinedReducer(state, action);
};

export default rootReducer;
